// src/config/api.config.js
import { CONSTANTS } from '../utils/constants';

const apiConfig = {
    API_BASE_URL: CONSTANTS.API_BASE_URL,
    REFRESH_INTERVAL: parseInt(process.env.REACT_APP_REFRESH_INTERVAL || "300", 10), // 5 minutes in seconds
    REGIONS: ['AUH', 'BOM', 'SIN', 'RUH', 'JNB']
  };
  
  export default apiConfig;